import React from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import EconomicsQuiz from './learning_module/EconomicsQuiz'
import TechnicalQuiz from './learning_module/TechnicalQuiz'
import Navbar from './Navbar'
import './LearningExercise.css'

export default function LearningExercise({ setToken }) {
  const navigate = useNavigate()
  const { moduleSlug, topicSlug } = useParams()
  const location = useLocation()
  
  console.log('🎯 LearningExercise - moduleSlug aus URL:', moduleSlug)
  console.log('📍 Location state:', location.state)
  
  // Titel aus dem State oder fallback basierend auf slug
  const moduleTitle = location.state?.moduleTitle || getModuleTitleFromSlug(moduleSlug)
  const topicTitle = topicSlug ? getTopicTitleFromSlug(topicSlug) : null

  function getModuleTitleFromSlug(slug) {
    console.log('🔍 Ermittle Titel für Slug:', slug)
    const titleMap = {
      'wirtschaft': 'Wirtschaft',
      'lernfeld-4': 'Ganzheitliche Aufgabe I (Betriebswirtschaftlich-technisch)',
      'lernfeld-5': 'Lernfeld 5',
      'lernfeld-6': 'Ganzheitliche Aufgabe II (Technisch-anwendungsorientiert)'
    }
    const title = titleMap[slug] || 'Unbekanntes Modul'
    console.log('📝 Titel gefunden:', title)
    return title
  }

  function getTopicTitleFromSlug(slug) {
    const map = {
      'netzplan': 'Netzplan',
      // Weitere Themen hier ergänzen
    }
    return map[slug] || slug
  }

  // Bestimme den Quiz-Typ basierend auf dem Modul und Thema
  const getQuizComponent = () => {
    if (moduleSlug === 'wirtschaft') {
      return <EconomicsQuiz moduleSlug={moduleSlug} moduleTitle={moduleTitle} />
    } else {
      // Nur das gewählte Thema laden
      return <TechnicalQuiz moduleSlug={moduleSlug} moduleTitle={moduleTitle} topicSlug={topicSlug} topicTitle={topicTitle} />
    }
  }

  // Bestimme, ob wir auf der Netzplan-Seite von Lernfeld-4 sind
  const isLernfeld4Netzplan = moduleSlug === 'lernfeld-4' && (topicSlug === 'netzplan' || !topicSlug);

  const handleLogout = () => {
    localStorage.removeItem('token')
    setToken(null)
    navigate('/login', { replace: true })
  }

  const handleStatistikClick = () => {
    navigate('/statistik')
  }

  const handleAccountClick = () => {
    navigate('/account')
  }

  const handleBackToLearning = () => {
    if (moduleSlug === 'lernfeld-4') {
      localStorage.removeItem('netzplan_lernfeld4');
    }
    navigate('/learning');
  }

  return (
    <div className="learning-exercise">
      <div className="background" />
      
      <Navbar 
        title={topicTitle || moduleTitle}
        onLogout={handleLogout}
        logoClickable={true}
        onLogoClick={handleBackToLearning}
        onStatistikClick={handleStatistikClick}
        onAccountClick={handleAccountClick}
      />

      {/* Hauptinhalt */}
      <div className="learning-exercise-content">
        <div className={`learning-exercise-container${isLernfeld4Netzplan ? ' lernfeld4-netzplan' : ''}`}> 
          {getQuizComponent()}
        </div>
      </div>
    </div>
  )
}